import { PlusIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import Loader from '../../../../../Loader';
import { AddingLearningDesign, Building, EditFormSubmissionError } from '../../../Edit/Store/Types';

interface Props {
  action: () => void;
  state: Building | EditFormSubmissionError | AddingLearningDesign;
}

function NewSectionButton({ action, state }: Props) {
  const button = (
    <button
      onClick={action}
      data-tooltip-id="add-section-button"
      data-intercom-target="builder-add-section-button"
      className={clsx(
        'flex w-full my-8 py-2 items-center justify-center',
        'border border-gray-400 border-dashed bg-gray-50 rounded-md',
      )}
    >
      <PlusIcon className="h-5 w-5" aria-hidden="true" />
      <T kind="Add a section" />
    </button>
  );

  switch (state.kind) {
    case 'building':
    case 'edit-form-submission-error':
      return <>{button}</>;
    case 'adding-learning-design':
      return (
        <>
          <Loader className="h-[409px] border rounded-lg bg-gray-50" />
          {button}
        </>
      );
  }
}

export default observer(NewSectionButton);
